module.exports = __webpack_public_path__ + "img/icon_solution03.0502278a.png";